module.exports = __webpack_public_path__ + "static/media/icon_card.1ef4f6ed.svg";